
import React from 'react';
import { Bar } from 'react-chartjs-2';
import 'chartjs-adapter-date-fns';
import { format, addYears } from 'date-fns';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';


ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  TimeScale
);


export default function BarChart({ Data }) {

  const labels = Data?.map(elm => elm.oem_tag)

  const options = {
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false, // Disable grid lines on the x-axis
        },
      },
      y: {
        grid: {
          display: false, // Disable grid lines on the y-axis
        },
        type: 'time',
        time: {
          unit: 'year',
        },
        ticks: {
          source: 'data'
        },
        min: '2021-11-07 00:00:00',
      }
    },
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'User Assets Details',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            const dateValue = new Date(context.parsed.y).toLocaleDateString(); // Format date value
            label += dateValue; // Display formatted date value

            // Assuming you have additional data in your 'Data' object
            const additionalData = Data[context.dataIndex]; // Get additional data based on the index
            label += ' | Asset Name: ' + (additionalData ? additionalData.name : ''); // Display additional data
            return label;
          }
        }
      }
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Issue Date',
        data: Data?.map(elm => elm.issueDate),
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
        label: 'Warranty Date',
        data: Data?.map(elm => elm.expDate),
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };
  return (<Bar options={options} data={data} />);
}
